import { areDisplayAdsEnabled } from "./adsUtilities";
import { getNativeAdPlacement, type NativeAdPlacement } from "owa-mail-ads-shared";

export default function areAdsEnabled(): boolean {
    return areDisplayAdsEnabled() || getNativeAdPlacement() != 0;
}
